/*
 *
 * OtpPopup
 *
 * @version 1.0.0
 * @author Elia Minozzi
 * @since 18-Jul-2025
*/

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import OtpPopup from './OtpPopup'
import { doShowToast, doHideToast } from 'Store/actions/toast'
import { doHidePopup } from 'Store/actions/popup'
import { nullSafe } from 'Utility/globalMethods'
import { doVerifyOtp, doRegenerateOtp, doResetState } from 'Store/actions/sca'

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators({ doShowToast, doHideToast }, dispatch),
  ...bindActionCreators({ doHidePopup }, dispatch),
  doVerifyOtp: (payload) => dispatch(doVerifyOtp(payload)),
  doRegenerateOtp: (payload) => dispatch(doRegenerateOtp(payload)),
  doResetState: () => dispatch(doResetState())
})

const mapStateToProps = state => ({
  title: nullSafe(() => state.popup.popupInfo.title, ''),
  maskedPhone: nullSafe(() => state.sca.scaMaskedPhone, ''),
  onClose: nullSafe(() => state.popup.popupInfo.onClose, () => { }),
  onCloseFlag: !!state.popup.popupInfo.onClose,
  isLoading: nullSafe(() => state.loading.localLoading.check_otp_aml, false)
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(OtpPopup)
